<div class="modal fade" [id]="modalId" tabindex="-1" [attr.aria-labelledby]="modalId + 'Label'" aria-hidden="true">
  <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" [id]="modalId + 'Label'">Adicionar Dependentes ao Plano</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
      </div>
      
      <div class="modal-body">
        <div class="alert alert-info">
          <div class="d-flex align-items-start">
            <i class="bi bi-info-circle me-2 mt-1"></i>
            <div>
              <strong>Informação:</strong> Adicione <strong>{{ qtyDependents }}</strong> dependente(s) a este plano. 
              O valor adicional será calculado automaticamente conforme as configurações do plano.
            </div>
          </div>
        </div>

        <!-- Formulário de Cadastro -->
        <form [formGroup]="dependentForm">
          <div class="row">
            <div class="col-lg-4">
              <app-select-input
                [id]="'documentTypeInputId'"
                [label]="'Tipo de Documento'"
                [options]="docTypesList"
                formControlName="documentType"
                (change)="onDocumentTypeChange()">
              </app-select-input>
            </div>

            <div class="col-lg-4">
              @if (dependentForm.get('documentType')?.value == 1) {
                <app-input-custom
                  [id]="'documentInputId'"
                  [label]="'Documento'"
                  [placeholder]="'Digite o CPF'"
                  [mask]="InputMaskTypesEnum.CPF"
                  formControlName="cpf"
                  (blur)="onSearchCPF()">
                </app-input-custom>
              } @else {
                <app-input
                  [id]="'documentInputId'"
                  [label]="'Documento'"
                  [placeholder]="'Digite o documento'"
                  [type]="InputTypeEnum.TEXT"
                  [maxLength]="9"
                  formControlName="document"
                  (blur)="onSearchCPF()">
                </app-input>
              }
            </div>

            <div class="col-lg-4">
              <app-input-custom
                [id]="'birthDateInputId'"
                [label]="'Data de Nascimento'"
                [placeholder]="'DD/MM/AAAA'"
                [mask]="InputMaskTypesEnum.DATA"
                [dropSpecialCharacters]="false"
                formControlName="birthDate"
                (blur)="onSearchCPF()">
              </app-input-custom>
            </div>            
          </div>

          <div class="row">
            <div class="col-lg-6">
              <app-input
                [id]="'nameInputId'"
                [label]="'Nome Completo'"
                [placeholder]="'Digite o nome completo'"
                [type]="InputTypeEnum.NAME" 
                [isUpperCase]="true"
                formControlName="name">
              </app-input>
            </div>
  
            <div class="col-lg-6">
              <app-select-input
                [id]="'sexInputId'"
                [label]="'Sexo'"
                [options]="sexOptions"
                formControlName="gender">
              </app-select-input>
            </div>
          </div>
          
          <div class="row">
            <div class="col-lg-4">
              <app-input
                [id]="'emailInputId'"
                [label]="'E-mail'"
                [placeholder]="'Digite seu e-mail'"
                [type]="InputTypeEnum.EMAIL"
                formControlName="email"
                (blur)="onEmailChange()">
              </app-input>
            </div>

            <div class="col-lg-4">
              <app-input-custom 
                [id]="'phoneInputId'"
                [label]="'Celular'" 
                [placeholder]="'Digite seu celular'"
                [mask]="InputMaskTypesEnum.PHONE"
                formControlName="phone"
                (blur)="onPhoneChange()">
              </app-input-custom>
            </div>

            <div class="col-lg-4">
              <app-select-input
                [id]="'relationshipDegreeInputId'"
                [label]="'Grau de Parentesco'"
                [options]="relationshipDegrees"
                formControlName="relationshipDegreeId">
              </app-select-input>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-12 d-flex justify-content-end gap-2">
              @if (isEditing()) {
                <app-button
                  [buttonOptions]="buttonCancelOptions"
                  (buttonClick)="cancelEdit()">
                </app-button>
                <app-button
                  [buttonOptions]="buttonUpdateOptions"
                  [disabled]="!validFields()"
                  (buttonClick)="addOrUpdateDependent()">
                </app-button>
              } @else {
                <app-button
                  [buttonOptions]="buttonAddOptions"
                  [disabled]="!validFields() || isLimitReached()"
                  (buttonClick)="addOrUpdateDependent()">
                </app-button>
              }
            </div>
          </div>
        </form>

        <hr class="my-4" />

        <!-- Lista de Dependentes Adicionados -->
        <div class="dependents-list">
          <h6 class="mb-3">Dependentes Adicionados ({{ dependentsList.length }}/{{ qtyDependents }})</h6>
          
          @if (dependentsList.length === 0) {
            <div class="alert alert-warning">
              <i class="bi bi-exclamation-triangle"></i>
              Nenhum dependente adicionado ainda.
            </div>
          } @else {
            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>Nome</th>
                    <th>Parentesco</th>
                    <th>Documento</th>
                    <th>Sexo</th>
                    <th>Data Nasc.</th>
                    <th>Valor Adicional</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  @for (dependent of dependentsList; track $index) {
                    <tr>
                      <td>{{ dependent.name }}</td>
                      <td>{{ getRelationshipDegreeName(dependent.relationshipDegreeId || '') }}</td>
                      <td>
                        {{ dependent.documentType == 1 ? 'CPF: ' + (dependent.cpf | cpf) : 'Passaporte: ' + dependent.cpf }}
                      </td>
                      <td>{{ dependent.gender === 'M' ? 'Masculino' : dependent.gender === 'F' ? 'Feminino' : 'Não informado' }}</td>
                      <td>{{ dependent.birthDate | date: 'dd/MM/yyyy' }}</td>
                      <td class="text-success fw-bold">{{ (dependent.configAmount || 0) | currency: 'BRL' }}</td>
                      <td>
                        <button 
                          type="button" 
                          class="btn btn-sm btn-warning me-1"
                          (click)="editDependent($index)"
                          title="Editar"
                          [disabled]="dependent.alredyExists">
                          <i class="bi bi-pencil"></i>
                        </button>
                        <button 
                          type="button" 
                          class="btn btn-sm btn-danger"
                          (click)="removeDependent($index)"
                          title="Remover"
                          [disabled]="isEditing()">
                          <i class="bi bi-trash"></i>
                        </button>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
        </div>
      </div>

      <div class="modal-footer justify-content-between">
        <div>
          <span class="text-end fw-bold">Total Adicional de Dependentes: </span>
          @if (calculatingAmounts) {
            <span class="spinner-border spinner-border-sm text-success" role="status" aria-label="Calculando"></span>
          } @else {
            <span class="text-success fw-bold">{{ getTotalDependentsAmount() | currency: 'BRL' }}</span>
          }
        </div>
        <app-button
          [buttonOptions]="buttonConfirmOptions"
          [disabled]="dependentsList.length < qtyDependents || calculatingAmounts"
          (buttonClick)="confirmAndClose()">
        </app-button>
      </div>
    </div>
  </div>
</div>
